__turbopack_context__.v({
  "avatar": "style-module-scss-module__eiqQdW__avatar",
  "breadcrumbsWrap": "style-module-scss-module__eiqQdW__breadcrumbsWrap",
  "content": "style-module-scss-module__eiqQdW__content",
  "despription": "style-module-scss-module__eiqQdW__despription",
  "leftSide": "style-module-scss-module__eiqQdW__leftSide",
  "name": "style-module-scss-module__eiqQdW__name",
  "rightSide": "style-module-scss-module__eiqQdW__rightSide",
  "role": "style-module-scss-module__eiqQdW__role",
  "socials": "style-module-scss-module__eiqQdW__socials",
  "wrapper": "style-module-scss-module__eiqQdW__wrapper",
});
